































































































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import CampaignService from '@/api/CampaignService';
import AdminService from '@/api/AdminService';
import flagKeys from '@/constants/flagKeys';
import eventBus from '@/utils/eventBus';
import { IEducationPlayerProps } from '@/componentsV2/molecules/EducationPlayer/EducationPlayer';
import LaunchRewardsProgramEmptyState from '@/componentsV2/organisms/LaunchRewardsProgramEmptyState/LaunchRewardsProgramEmptyState.vue';
import ProviderFeatureEmptyState from '@/componentsV2/organisms/ProviderFeatureEmptyState/ProviderFeatureEmptyState.vue';
import { needLaunchRewardsProgram } from '@/utils/start-guide';
import BannerActivateWidget from '../BannerActivateWidget/BannerActivateWidget.vue';
import { needProviderConnected } from '@/utils/provider';
import BannerActivateOnlineInStore from '../BannerActivateOnlineInStore/BannerActivateOnlineInStore.vue';
import BannerActivateRewards from '../BannerActivateRewards/BannerActivateRewards.vue';
import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';
import {
  getIsRewardActivated,
  isFeatureAllowsNotHaveReward
} from '@/utils/rewards';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import BillingNetworkTag from '@/componentsV2/atoms/BillingNetworkTag/BillingNetworkTag.vue';
import { IBusinessType } from '@/models/business';
import BannerReactiveBilling from '../BannerReactiveBilling/BannerReactiveBilling.vue';
import { appIsActive, widgetIsEnabled } from '@/router/validators/utils';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    LaunchRewardsProgramEmptyState,
    BannerActivateWidget,
    ProviderFeatureEmptyState,
    BannerActivateOnlineInStore,
    BannerActivateRewards,
    BannerActivateBilling,
    BannerReactiveBilling,
    BillingNetworkTag
  }
})
export default class ContentContainer extends Mixins(Vue, BillingModel) {
  @Prop({ default: '' }) readonly title?: string;
  @Prop({ default: '' }) readonly titleIconSrc?: string;
  @Prop({ default: false }) readonly transparent?: boolean;
  @Prop({ default: false }) readonly borderless?: boolean;
  @Prop({ default: false }) readonly withClose?: boolean;
  @Prop({ default: '' }) readonly padding?: string;
  @Prop() readonly contentMargin?: string;
  @Prop(Array) readonly breadcrumb?: any;
  @Prop({ default: false }) readonly noScroll?: boolean;
  @Prop({ default: false }) readonly scrollAll?: string;
  @Prop({ default: false }) readonly needsWidget?: boolean;
  @Prop({ default: false }) readonly widgetHasToBeOnlineOnly?: boolean;
  @Prop({ default: true }) readonly isEmptyState?: boolean;
  @Prop({ default: false }) readonly needsActivedRewards?: boolean;
  @Prop({ default: false }) readonly needsActivedBilling?: boolean;

  @Prop({ default: false }) readonly loading?: boolean;

  @Prop() readonly breadcrumbGATitle?: string;
  @Prop() readonly educationVideo?: IEducationPlayerProps;

  service: CampaignService = new CampaignService();
  adminService = new AdminService();

  gotoPath(breadcrumb: { path: string; label: string }) {
    if (this.breadcrumbGATitle) {
      this.$analytics({
        eventCategory: this.breadcrumbGATitle,
        eventAction: 'click',
        eventLabel: `Clicked on "${breadcrumb.label}"`
      });
    }

    this.$router.push(breadcrumb.path);
  }

  getOffset(el: HTMLDivElement) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }

  onOpenVideo() {
    if (!this.educationVideo) return;

    const offset = this.getOffset(document.querySelector(
      '.page__education'
    ) as HTMLDivElement);

    eventBus.$emit('openEducationPlayer', {
      ...this.educationVideo,
      offset
    });
  }

  mounted() {
    if (this.educationVideo && this.educationVideo.initialOpened)
      setTimeout(() => {
        this.onOpenVideo();
      }, 1000);
  }

  get needRewardsProgramEmptyState() {
    return needLaunchRewardsProgram(true);
  }

  get needProviderEmptyState() {
    return (
      needProviderConnected(this.$route as any) &&
      this.isEmptyState &&
      !this.loading &&
      (this.isBillingModuleV4 ? !this.inactiveBilling : true)
    );
  }

  get hasEmptyState() {
    return this.needRewardsProgramEmptyState || this.needProviderEmptyState;
  }

  get showActivateBillingBanner() {
    return (
      this.needsActivedBilling &&
      !this.loading &&
      !this.hasEmptyState &&
      this.inactiveBilling &&
      !this.isEmptyState
    );
  }

  get welcomeCtaText() {
    const routeName =
      this.$route &&
      this.$route.meta &&
      this.$route.meta.navbar &&
      this.$route.meta.navbar.name;

    return `Explore ${this.title || routeName}`;
  }

  get showBannerRewards() {
    return (
      this.needsActivedRewards &&
      !this.hasEmptyState &&
      !this.loading &&
      !this.inactiveBilling &&
      !this.rewardsActive
    );
  }

  get showReactiveBillingBanner() {
    return (
      this.toBeCanceledBilling &&
      this.needsActivedBilling &&
      !this.showBannerWidget &&
      !this.showBannerRewards &&
      !this.hasEmptyState &&
      !this.loading
    );
  }

  get isOnlineOnly() {
    return this.business.type === IBusinessType.ONLINE;
  }

  get widgetDeactivated() {
    return (
      !widgetIsEnabled() &&
      this.getFlags.includes(flagKeys.widgetDeactivationAlerts) &&
      (!appIsActive() || (this.isOnlineOnly || !this.widgetHasToBeOnlineOnly))
    );
  }

  get showBannerWidget() {
    return (
      this.needsWidget &&
      !this.hasEmptyState &&
      !this.loading &&
      !this.isShowRewardsBanner &&
      !this.inactiveBilling &&
      this.widgetDeactivated
    );
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get toBeCanceledBilling() {
    if (!this.getFlags.includes(flagKeys.billingModuleV2)) return false;

    return this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED;
  }

  get showBillingTag() {
    if (!this.getFlags.includes(flagKeys.billingModuleV2)) return false;

    return (
      this.billingStatus !== EBillingStatusTypes.UNAVAILABLE &&
      !this.isEmptyState &&
      this.needsActivedBilling &&
      !this.loading
    );
  }

  get allowRewardAccess() {
    return (
      this.business.type === IBusinessType.INSTORE &&
      this.$route &&
      this.$route.meta &&
      this.$route.meta.$group &&
      this.$route.meta.$group.id !== 'loyalty-program'
    );
  }

  get isShowRewardsBanner() {
    if (this.allowRewardAccess) return false;
    return !getIsRewardActivated();
  }

  get rewardsActive() {
    if (isFeatureAllowsNotHaveReward() || this.allowRewardAccess) return true;
    return getIsRewardActivated();
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get pageTitle() {
    return this.hasEmptyState && this.isMobileDevice ? '' : this.title;
  }

  get margin() {
    if (this.contentMargin) {
      return `margin: ${this.contentMargin};`;
    }
    return '';
  }

  get backgroundColor() {
    if (this.transparent) return 'transparent';
    return 'var(--background-system)';
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  get getPadding() {
    if (this.padding) return this.padding;
    if (this.borderless) return '0';
    return '40px 27px 0';
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showTutorialButton() {
    return (
      this.educationVideo && this.getFlags.includes(flagKeys.videoEducation)
    );
  }

  get hasAdminBar() {
    return this.$route.meta.superRoot;
  }

  get isSuperAdmin() {
    return this.$store.getters['business/isRootView'];
  }

  get calculateHeight() {
    let start = 0;
    if (this.hasAdminBar || this.isImpersonated) {
      start = start + 71 + 40 + 41;
    }
    if (!this.borderless) {
      start = start + 40;
    }
    return start;
  }

  get showBannerActivateOnlineInStore() {
    return (
      this.$route.meta.$group &&
      this.$route.meta.$group.id === 'loyalty-program' &&
      !this.inactiveBilling
    );
  }
}
